import React from 'react';

const Contact = ({contactEmail, contactPara, socialLinks})=>{

    return (
      <>
      </>
    );
}

export default Contact